import { Card, Heading, List } from '@utilitywarehouse/hearth-react';

import { SHARE_URL } from '@features/Remote/constants';

import { LobbyDetailsItem } from './DetailsItem';
import './styles.scss';

interface LobbyDetailsProps {
  code: string;
}

const LobbyDetails = ({ code }: LobbyDetailsProps) => {
  const baseUrl = process.env.BASE_URL;
  const linkBase = `${location.host}${baseUrl ?? '/'}`;

  const joinLinkBase = `${linkBase}remote/join/${code}`;

  return (
    <Card
      variant="emphasis"
      colorScheme="neutralSubtle"
      paddingNone
      direction="column"
      shadowColor="functional"
    >
      <Heading size="md" className="remote__LobbyDetailsHeading">
        Appointment details
      </Heading>
      <List>
        <LobbyDetailsItem
          value={SHARE_URL}
          preview={SHARE_URL}
          label="Website URL"
        />
        <LobbyDetailsItem
          value={code}
          preview={code}
          label="Appointment code"
          testId="invite-appointment-code"
        />
        <LobbyDetailsItem
          value={`${location.protocol}//${joinLinkBase}`}
          preview={joinLinkBase}
          label="Meeting link"
        />
      </List>
    </Card>
  );
};

export { LobbyDetails };
